import { render, staticRenderFns } from "./kt&gItemInfo.vue?vue&type=template&id=d2e9925a&"
import script from "./kt&gItemInfo.vue?vue&type=script&lang=js&"
export * from "./kt&gItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./kt&gItemInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports